import React from 'react'

const RequiredMarked = ({right}) => {
  return (
    <span className={`${right ? 'ml-1' : 'mr-1' } text-danger`}>*</span>
  )
}

export default RequiredMarked